<template>
  <div>
    <div class="row">
      <div v-for="(card,index) in cards" :key="card.title">
        <div :class="{lightgrey: index % 2 === 0}" class="col s12">
          <div class="col s12 m10 l8 offset-m1 offset-l2">
            <h2 class="header">{{$t(card.title)}}</h2>
            <div class="card horizontal">
              <div class="card-image">
                <img :src="card.img.link" :alt="$t(card.img.alt)"/>
              </div>
              <div class="card-stacked">
                <div class="card-content">
                  <p v-html="$t(card.desc)"></p>
                </div>
                <div class="card-action" :class="{hide: card.action === '' }"><p v-html="$t(card.action)"></p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CSharp',
    data () {
      return {
        cards: [{
          title: 'cs.twitter.title',
          img: {link: 'static/img/twitter.jpg', alt: 'cs.twitter.alt.pict'},
          desc: 'cs.twitter.desc',
          action: 'cs.twitter.action'
        }, {
          title: 'cs.discord.title',
          img: {link: 'static/img/discord.png', alt: 'cs.discord.alt.pict'},
          desc: 'cs.discord.desc',
          action: 'cs.discord.action'
        }, {
          title: 'cs.mathador.title',
          img: {link: 'static/img/mathador.jpg', alt: 'cs.mathador.alt.pict'},
          desc: 'cs.mathador.desc',
          action: 'cs.mathador.action'
        }]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CSharp.vue